const NATIVE_UA = /ZeedcomApp\//;

type ShellBridge = {
  syncAuth?: (access: string, refresh: string, userId: number, storeId: number) => void;
  syncApiBase?: (base: string) => void;
  publishWidgetSnapshot?: (json: string) => void;
  clearAuth?: () => void;
  widgetConfigChanged?: () => void;
  setDark?: (dark: boolean) => void;
};

function bridge(): ShellBridge | null {
  if (typeof window === 'undefined') return null;
  if (!NATIVE_UA.test(navigator.userAgent)) return null;
  const shell = (window as unknown as { ZeedcomShell?: ShellBridge }).ZeedcomShell;
  return shell || null;
}

export function isZeedcomNativeApp(): boolean {
  return typeof navigator !== 'undefined' && NATIVE_UA.test(navigator.userAgent);
}

export function syncNativeAuth(
  accessToken: string | null,
  refreshToken: string | null,
  userId: number | null | undefined,
  storeId: number | null | undefined
): void {
  const shell = bridge();
  const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  if (apiBase.startsWith('https://')) {
    try {
      shell?.syncApiBase?.(apiBase);
    } catch {
      /* ignore */
    }
  }
  if (!shell?.syncAuth) return;
  if (!accessToken && !refreshToken) {
    shell.clearAuth?.();
    return;
  }
  try {
    shell.syncAuth(
      accessToken || '',
      refreshToken || '',
      userId && userId > 0 ? userId : 0,
      storeId && storeId > 0 ? storeId : 0
    );
  } catch {
    /* bridge may throw if WebView torn down */
  }
}

export function clearNativeAuth(): void {
  try {
    bridge()?.clearAuth?.();
  } catch {
    /* ignore */
  }
}

export function publishNativeWidgetSnapshot(data: unknown): void {
  const shell = bridge();
  if (!shell?.publishWidgetSnapshot || data == null) return;
  try {
    shell.publishWidgetSnapshot(JSON.stringify(data));
  } catch {
    /* bridge may throw if WebView torn down */
  }
}

export function notifyNativeWidgetConfigChanged(): void {
  try {
    bridge()?.widgetConfigChanged?.();
  } catch {
    /* ignore */
  }
}
